import Abstract from './abstract';
import Body from '../body';

export default () => {
  const steps = [
    {
      selector: '[data-guide="course-catalog@main:publish"]',
      content: (
        <Body title="点击发布，对外开放课程" description="发布成功后，登陆爱课件可以看到该课程" />
      ),
    },
    {
      selector: '[data-guide="course-catalog@catalog:create"]',
      content: <Body title="点击新建教学课件" description="或添加子目录，在子目录中添加教学课件" />,
    },
  ];

  return <Abstract steps={steps} scene="catalog" />;
};
